// Environment configuration for shared services
// This file is generated during deployment with environment-specific values
// DO NOT EDIT MANUALLY - it will be overwritten during build

export const config = {
  // Default values for development
  API_BASE_URL: 'http://localhost:3000',
  VERSION: 'dev',
  ENVIRONMENT: 'development',
  BUILD_DATE: new Date().toISOString(),
  // Analytics (Feature Flags) - set your API key here for local dev
  ANALYTICS_API_KEY: 'phc_bUJJAKnnevQC4gAlaZp4Bu9WD1C8Pq6xON6FpwzHxuz',
  ANALYTICS_HOST: 'https://us.i.posthog.com'
};

export default config;
